// extracted by mini-css-extract-plugin
module.exports =  {"tc-list-checkbox":"HeaderCheckbox-module__tc-list-checkbox____4A4w"};